import { components } from "./components/index";
import { events } from "./events/index";

const GeneralSection = {
  components,
  events
};

export { GeneralSection };